import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 2.09a6 6 0 0 0-1.455 11.82.81.81 0 0 1-.045-.284v-1.021h-.75a1.025 1.025 0 0 1-.945-.51c-.195-.36-.226-.915-.72-1.26-.151-.12-.031-.24.134-.226a1.578 1.578 0 0 1 .81.615.767.767 0 0 0 .8.39 5.978 5.978 0 0 0 .841-.06 1.854 1.854 0 0 1 .8-.975C5.45 10.339 4.49 9.349 4.49 8a2.472 2.472 0 0 1 .675-1.621c-.135-.465-.315-1.425.06-1.8a2.129 2.129 0 0 1 1.575.734 4.623 4.623 0 0 1 1.455-.24 4.552 4.552 0 0 1 1.455.24 2.129 2.129 0 0 1 1.575-.735c.36.36.2 1.335.045 1.8A2.432 2.432 0 0 1 11.99 8c0 1.35-.945 2.34-2.94 2.55a2.087 2.087 0 0 1 .945 1.7v1.367c0 .045-.015.09-.015.135A6 6 0 0 0 8 2.09Z';
const draw24px =
  'M12,2.13a10,10,0,0,0-2.42,19.7,1.38,1.38,0,0,1-.08-.48v-1.7H8.25a1.73,1.73,0,0,1-1.58-.85c-.32-.6-.37-1.52-1.2-2.1-.25-.2,0-.4.23-.37a2.66,2.66,0,0,1,1.35,1A1.26,1.26,0,0,0,8.37,18a9.45,9.45,0,0,0,1.4-.1,3.1,3.1,0,0,1,1.33-1.62c-3.35-.4-4.95-2.05-4.95-4.3a4.11,4.11,0,0,1,1.12-2.7c-.22-.78-.52-2.38.11-3A3.52,3.52,0,0,1,10,7.5a7.72,7.72,0,0,1,2.42-.4,7.59,7.59,0,0,1,2.43.4,3.52,3.52,0,0,1,2.62-1.22c.6.6.33,2.22.08,3a4,4,0,0,1,1.1,2.7c0,2.25-1.58,3.9-4.9,4.25a3.48,3.48,0,0,1,1.58,2.82v2.28c0,.08,0,.15,0,.22A10,10,0,0,0,12,2.13Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LogoGitHubIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'logoGitHub'),
) as IconWithRender;

LogoGitHubIcon.displayName = 'LogoGitHubIcon';
LogoGitHubIcon.propTypes = Icon.propTypes;
LogoGitHubIcon.renderIcon = (props) => <LogoGitHubIcon {...props} />;
export default LogoGitHubIcon;
